import React from 'react'

function Info(){
    return (
        <div>
            Group Support Dialog<br/>
            this should be quick reference slides highlighting the features of Group Support.
        </div>
    )
}
export default Info
